import TipoNotaForm from './tipo_notas/TipoNotaForm.vue';
import TipoNotaConversionForm from './tipo_notas/TipoNotaConversionForm.vue';
import NotificacionesForm from './items_diarios/NotificacionesForm.vue';

export default {
  install: (app, _options) => {
    app.component('CalificacionesTipoNotaForm', TipoNotaForm)
      .component('CalificacionesTipoNotaConversionForm', TipoNotaConversionForm)
      .component('CalificacionesItemsDiariosNotificacionesForm', NotificacionesForm);
  },
};
